<template>
  <div>
    <v-alert
      v-if="showUpgradeTeamWarning"
      type="warning"
      outlined
      text
      icon="mdi-alert"
      prominent
      class="text-body-2"
    >
      <div v-if="usedTeamMembersPercentage >= percentageWarnThreshold">
        {{ $t('Team members') }}: <span class="font-weight-bold">{{ numTeamMembers }}/{{ teamMembersLimit }} ({{ usedTeamMembersPercentage }}%)</span>
      </div>
      <div v-if="usedFaqsPercentage >= percentageWarnThreshold">
        {{ $t('FAQs') }}: <span class="font-weight-bold">{{ faqs.length }}/{{ faqsLimit }} ({{ usedFaqsPercentage }}%)</span>
      </div>
      <div v-if="usedQuestionsPercentage >= percentageWarnThreshold && teamPlan !== 'Enterprise'">
        {{ $t('Total number of questions') }}: <span class="font-weight-bold">{{ numQuestions }}/{{ numQuestionsAllowed }} ({{ usedQuestionsPercentage }}%)</span>
      </div>
      <div v-if="usedStoragePercentage >= percentageWarnThreshold">
        {{ $t('Used storage') }}: <span class="font-weight-bold">{{ usedStorage }}</span>
      </div>

      <upgrade-team-button
        class="mt-4"
        small
      />
    </v-alert>

    <p class="mb-0 text-h6">
      <span v-if="$page.props.user.name">
        {{ $t('Welcome') }}, {{ $page.props.user.name }}!
      </span>
      <span v-else>
        {{ $t('Welcome') }}!
      </span>
    </p>
    <div class="flex-wrap mb-4 d-flex align-center">
      <p class="mb-0 mr-4 body-1">
        {{ $t('You are currently using team') }} "{{ $page.props.user.current_team.name }}" ({{ $page.props.user.current_team.plan }})
        <br>
        <span
          v-if="!$page.props.user.current_team.owned_by_user"
          class="caption"
        >
          {{ $t('Team owner') }}: {{ $page.props.user.current_team.owner_email }}
        </span>
      </p>
      <div>
        <upgrade-team-button small />
        <v-menu
          v-if="$page.props.user.teams.length > 1"
          offset-y
        >
          <template #activator="{ on, attrs }">
            <v-btn
              class="mt-sm-0 ml-2"
              small
              v-bind="attrs"
              v-on="on"
            >
              {{ $t('Switch team') }}
              <v-icon right>
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <switch-team-list />
        </v-menu>
      </div>
    </div>

    <v-row v-if="numTotalFaqs > 0">
      <v-col
        cols="12"
        sm="4"
      >
        <stats-card
          :color="colors.views"
          :title="$t('Team members')"
          :content="numTeamMembers"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
      >
        <stats-card
          :color="colors.interactions"
          :title="$t('Total number of questions')"
          :content="numQuestions"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
      >
        <stats-card
          :color="colors.avgInteractions"
          :title="$t('Used storage')"
          :content="usedStorage"
        />
      </v-col>
    </v-row>

    <!-- <v-row v-if="numTotalFaqs > 0">
      <v-col
        cols="12"
        sm="4"
      >
        <stats-card-table
          :title="$t('Last created questions')"
          :color="colors.positive"
        >
          <thead />
          <tbody>
            <tr v-if="lastCreatedQuestions.length === 0">
              <td>-</td>
            </tr>
            <tr
              v-for="(question, idx) in lastCreatedQuestions"
              :key="`last-created-${question.id}-${idx}`"
              rowspan="3"
            >
              <td
                class="px-4 py-4 text-truncate"
                style="max-width: 1px"
              >
                <p class="caption mb-1">
                  {{ faqsKeyedById[question.faq_id].default_translation.name }} - {{ question.created }}
                </p>
                <inertia-link :href="route('faq.question.edit', [question.faq_id, question.id])">
                  {{ question.default_translation.title }}
                </inertia-link>
              </td>
            </tr>
          </tbody>
        </stats-card-table>
      </v-col>
      <v-col
        cols="12"
        sm="4"
      >
        <stats-card-table
          :title="$t('Last updated questions')"
          :color="colors.positive"
        >
          <thead />
          <tbody>
            <tr v-if="lastUpdatedQuestions.length === 0">
              <td>-</td>
            </tr>
            <tr
              v-for="(question, idx) in lastUpdatedQuestions"
              :key="`last-updated-${question.id}-${idx}`"
            >
              <td
                class="px-4 py-4 text-truncate"
                style="max-width: 1px"
              >
                <p class="caption mb-1">
                  {{ faqsKeyedById[question.faq_id].default_translation.name }} - {{ question.last_modified }}
                </p>
                <inertia-link :href="route('faq.question.edit', [question.faq_id, question.id])">
                  {{ question.default_translation.title }}
                </inertia-link>
              </td>
            </tr>
          </tbody>
        </stats-card-table>
      </v-col>
      <v-col
        cols="12"
        sm="4"
      >
        <stats-card-table
          :title="$t('Least updated questions')"
          :color="colors.negative"
        >
          <thead />
          <tbody>
            <tr v-if="leastUpdatedQuestions.length === 0">
              <td>-</td>
            </tr>
            <tr
              v-for="(question, idx) in leastUpdatedQuestions"
              :key="`least-updated-${question.id}-${idx}`"
            >
              <td
                class="px-4 py-4 text-truncate"
                style="max-width: 1px"
              >
                <p class="caption mb-1">
                  {{ faqsKeyedById[question.faq_id].default_translation.name }} - {{ question.last_modified }}
                </p>
                <inertia-link :href="route('faq.question.edit', [question.faq_id, question.id])">
                  {{ question.default_translation.title }}
                </inertia-link>
              </td>
            </tr>
          </tbody>
        </stats-card-table>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col
        cols="12"
        sm="7"
      >
        <pending-team-invitations
          v-if="invitations.length > 0"
          class="mb-6"
          :invitations="invitations"
        />

        <faqs
          :faqs="faqs"
          :active-tab="activeFaqTab"
          :available-languages="availableLanguages"
        />
      </v-col>
      <v-col
        v-if="$page.props.user.is_demo || ! $page.props.user.verified"
        cols="12"
        sm="5"
      >
        <verify-email
          v-if="! $page.props.user.verified"
          :days-left="verifyEmailDaysLeft"
        />

        <convert-demo-form
          v-if="$page.props.user.is_demo"
          :demo-expires-days="demoExpiresDays"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy';
import reduce from 'lodash/reduce';
import i18n from '@/plugins/vue-i18n';
import ConvertDemoForm from '@/components/dashboard/ConvertDemoForm';
import PendingTeamInvitations from '@/components/dashboard/PendingTeamInvitations';
import Faqs from '@/components/faq/Faqs';
import Layout from '@/components/shared/TheLayout';
import VerifyEmail from '@/components/dashboard/VerifyEmail';
import colors from 'vuetify/lib/util/colors';

export default {
  components: {
    PendingTeamInvitations,
    ConvertDemoForm,
    Faqs,
    VerifyEmail
  },

  layout: (h, page) => h(Layout, {
    props: {
      pageTitle: i18n.t('Dashboard')
    }
  }, [page]),

  props: {
    invitations: {
      type: Array,
      required: true
    },
    numTeamMembers: {
      type: [Number, String],
      required: true
    },
    numTotalFaqs: {
      type: [Number, String],
      required: true
    },
    usedStorage: {
      type: String,
      required: true
    },
    usedStoragePercentage: {
      type: [Number, String],
      required: true
    },
    teamMembersLimit: {
      type: [Number],
      required: true
    },
    faqsLimit: {
      type: [Number],
      required: true
    },
    questionLimit: {
      type: [Number],
      required: false,
      default: null
    },
    faqs: {
      type: Array,
      required: true
    },
    activeFaqTab: {
      type: String,
      required: true
    },
    availableLanguages: {
      type: Array,
      required: true
    },
    verifyEmailDaysLeft: {
      type: Number,
      required: false,
      default: null
    },
    lastCreatedQuestions: {
      type: Array,
      required: true
    },
    lastUpdatedQuestions: {
      type: Array,
      required: true
    },
    leastUpdatedQuestions: {
      type: Array,
      required: true
    },

  },

  data() {
    return {
      percentageWarnThreshold: 80,
      colors: {
        views: colors.teal.base,
        interactions: colors.purple.base,
        avgInteractions: colors.blue.base,
        positive: colors.green.base,
        negative: colors.red.base
      },
    }
  },

  computed: {
    showUpgradeTeamWarning() {
      return (
        (this.usedTeamMembersPercentage >= this.percentageWarnThreshold && this.$page.props.user.current_team.plan !== 'Personal') ||
        this.usedFaqsPercentage >= this.percentageWarnThreshold ||
        (this.usedQuestionsPercentage >= this.percentageWarnThreshold && this.teamPlan !== 'Enterprise') ||
        this.usedStoragePercentage >= this.percentageWarnThreshold
      );
    },

    teamPlan() {
      return this.$page.props.user.current_team.plan;
    },

    numQuestions() {
      return reduce(this.faqs, (acc, faq) => faq.questions.length + acc, 0);
    },

    numQuestionsAllowed() {
      return this.questionsLimit * this.faqsLimit;
    },

    faqsKeyedById() {
      return keyBy(this.faqs, 'id');
    },

    usedTeamMembersPercentage() {
      return Math.round(((this.numTeamMembers / this.teamMembersLimit) * 100) * 1);
    },

    usedFaqsPercentage() {
      if (this.faqs.length > 0) {
        return Math.round(((this.faqs.length / this.faqsLimit) * 100) * 1);
      }

      return 0;
    },

    usedQuestionsPercentage() {
      const numAllowedQuestions = this.questionsLimit * this.faqsLimit;
      const numQuestions = reduce(this.faqs, (acc, faq) => faq.questions.length + acc, 0);

      if (numQuestions > 0) {
        return Math.round((( numQuestions / numAllowedQuestions) * 100) * 1);
      }

      return 0;
    },
  }
}
</script>